import {
  FETCH_STATIC_CONTENT_INIT,
  StaticContentActionTypes,
  StaticContentState,
} from './types';
import { staticContentStorage } from 'utils/staticContent/staticContentStorage';

const initialState: StaticContentState = {
  loading: false,
  data: staticContentStorage.getContent(),
  error: null,
};

export default function staticContentReducer(
  state = initialState,
  action: StaticContentActionTypes
): StaticContentState {
  switch (action.type) {
    case FETCH_STATIC_CONTENT_INIT: {
      return {
        ...state,
        loading: true,
        data: null,
      };
    }
    case 'FETCH_STATIC_CONTENT_SUCCESS': {
      const { data } = action;
      return {
        ...state,
        loading: false,
        data,
      };
    }
    case 'FETCH_STATIC_CONTENT_ERROR': {
      const { error } = action;
      return {
        ...state,
        loading: false,
        error: error,
      };
    }
    default:
      return state;
  }
}
